'use strict';/* global define */define('modules/custom-forms/services/custom-builder-form-config/index',['require','exports','module','angular'],function(require,exports,module){'use strict';
     factory.$inject = ["$resource", "$q", "API_ENDPOINT"];var ng=require('angular');// @ngInject
function factory($resource,$q,API_ENDPOINT){// jshint validthis:true
// jshint latedef:false
var config={};return{get:get,flush:flush};// ---
/**
     * Flush the cached config object
     *
     * @tested
     */function flush(){config={};}/**
     * Get forms config
     *
     * @tested
     */function get(){if(!config.$resolved){var deferred=$q.defer();config.$promise=deferred.promise;$resource(API_ENDPOINT+'forms/config').get().$promise.then(function(data){ng.extend(config,data);deferred.resolve(data);}).catch(function(reason){deferred.reject(reason);});}return config;}}module.exports=factory;});
